import { render, staticRenderFns } from "./GuildDetail.vue?vue&type=template&id=2ec254be&"
import script from "./GuildDetail.vue?vue&type=script&lang=js&"
export * from "./GuildDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports